import { PortalRequest as request } from "@/utils/request";

export const getConferenceToken = (extra) => {
  return request({
    url: "/conference/token",
    method: "post",
    data: extra,
  });
};
